module.exports = __webpack_public_path__ + "static/media/application-5-crop-tablet.98fadabf.jpg";